import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RequestView from '../../modal/RequestView';
import { Request } from '../../types';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faClock, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import AttendeeRequestReason from './AttendeeRequestReason';
//
// Вспомогательный компонент показывающий есть или нет у нас запрос с этим участником.
// UPDATE: Заказчик попросил не писать оповещение о том, что запрос был отменен админом,
// поэтому в этом случае будем делать вид что запроса просто не было.
//
interface AttendeeRequestStatusProps {
    request?: Request; // Запрос
    attendee_id: number; // Идентификатор собеседника
};

const AttendeeRequestStatus: FC<AttendeeRequestStatusProps> = ({ request, attendee_id }) => {
	const { t } = useTranslation();
    const [ isRequestViewOpen, setIsRequestViewOpen ] = useState(false);

    // Нет запросов с этим участником 
    if(!request) return <p className='success b'>{t('attendee.norequest')}</p>;

    // Есть подтвержденная встреча
    if(request.status === 'approved') return <p className='success b'>
        <Icon icon={faCircleCheck}/>&nbsp;&nbsp;
        {t('attendee.approved1')}
        <span className='Dotted b' onClick={() => setIsRequestViewOpen(true)}>
            {t('attendee.approved2')}
        </span>
        <RequestView request={request} isOpen={isRequestViewOpen} onClose={() => setIsRequestViewOpen(false)}/>
    </p>;

    // Есть отмененный запрос
    if(request.status === 'rejected') {
        if(request.from_id === attendee_id) {
            // Запрос был инициирован участником
            if(!request.actor_id) {
                // Запрос отменен админом
                // return <p className='error b'><Icon icon={faCircleXmark}/>&nbsp;&nbsp;{t('attendee.rejected.by_admin')}</p>;
                return <p className='success b'>{t('attendee.norequest')}</p>;
            } else if(request.actor_id === attendee_id) {
                // Запрос был отозван участником
                return <p className='error b'><Icon icon={faCircleXmark}/>&nbsp;&nbsp;{t('attendee.rejected.by_participant_own')}</p>;
            } else {
                // Запрос был отклонен нами
                return (<p className='error b'>
                    <Icon icon={faCircleXmark}/>&nbsp;&nbsp;{t('attendee.rejected.by_me')}
                    <AttendeeRequestReason reason={request.reason}/>
                </p>);
            }
        } else {
            // Запрос был инициирован нами
            if(!request.actor_id) {
                // Запрос отменен админом
                // return <p className='error b'><Icon icon={faCircleXmark}/>&nbsp;&nbsp;{t('attendee.rejected.by_admin_my')}</p>;
                return <p className='success b'>{t('attendee.norequest')}</p>;
            } else if(request.actor_id === attendee_id) {
                // Запрос был отклонен участником
                return (<p className='error b'>
                    <Icon icon={faCircleXmark}/>&nbsp;&nbsp;{t('attendee.rejected.by_participant')}
                    <AttendeeRequestReason reason={request.reason}/>
                </p>);
            } else {
                // Запрос был отозван нами
                return <p className='error b'><Icon icon={faCircleXmark}/>&nbsp;&nbsp;{t('attendee.rejected.by_me_my')}</p>;
            }
        }
    }

    // Есть отмененная встреча
    if(request.status === 'cancelled') {
        if(request.from_id === attendee_id) {
            // Запрос был инициирован участником
            if(!request.actor_id) {
                // Встреча отменена админом
                // return <p className='error b'><Icon icon={faCircleXmark}/>&nbsp;&nbsp;{t('attendee.cancelled.by_admin')}</p>;
                return <p className='success b'>{t('attendee.norequest')}</p>;
            } else if(request.actor_id === attendee_id) {
                // Встреча была отменена участником
                return (<p className='error b'>
                    <Icon icon={faCircleXmark}/>&nbsp;&nbsp;{t('attendee.cancelled.by_participant_own')}
                    <AttendeeRequestReason reason={request.reason}/>
                </p>);
            } else {
                // Встреча была отменена нами
                return (<p className='error b'>
                    <Icon icon={faCircleXmark}/>&nbsp;&nbsp;{t('attendee.cancelled.by_me')}
                    <AttendeeRequestReason reason={request.reason}/>
                </p>);
            }
        } else {
            // Запрос был инициирован нами
            if(!request.actor_id) {
                // Встреча отменена админом
                // return <p className='error b'><Icon icon={faCircleXmark}/>&nbsp;&nbsp;{t('attendee.cancelled.by_admin_my')}</p>;
                return <p className='success b'>{t('attendee.norequest')}</p>;
            } else if(request.actor_id === attendee_id) {
                // Встреча была отменена участником
                return (<p className='error b'>
                    <Icon icon={faCircleXmark}/>&nbsp;&nbsp;{t('attendee.cancelled.by_participant')}
                    <AttendeeRequestReason reason={request.reason}/>
                </p>);
            } else {
                // Встреча была отменена нами
                return (<p className='error b'>
                    <Icon icon={faCircleXmark}/>&nbsp;&nbsp;{t('attendee.cancelled.by_me_my')}
                    <AttendeeRequestReason reason={request.reason}/>
                </p>);
            }
        }
    }

    // Есть запрос в стадии согласования
    return (
        <p className='success b'>
            <Icon icon={faClock}/>&nbsp;&nbsp;
            {/* Запрос отправил участник */}
            {request.from_id === attendee_id ? <>
                {t('attendee.from1')}
                <span className='Dotted b' onClick={() => setIsRequestViewOpen(true)}>
                    {t('attendee.from2')}
                </span>
            {/* Запрос отправили мы */}
            </> : <>
                {t('attendee.to1')}
                <span className='Dotted b' onClick={() => setIsRequestViewOpen(true)}>
                    {t('attendee.to2')}
                </span>
            </>}
            {/* Кто должен подтвердить встречу */}
            {request.actor_id === attendee_id ? <>{t('attendee.needaction')}</> : <>{t('attendee.waiting')}</>}
            <RequestView request={request} isOpen={isRequestViewOpen} onClose={() => setIsRequestViewOpen(false)}/>
        </p>
    );
};

export default AttendeeRequestStatus;
